import { createSlice } from '@reduxjs/toolkit'

export const errorSlice = createSlice({
    name: 'error',
    initialState: {
        value: []
    },
    reducers: {
        errorAction: (state, action) => {
            state.value = action.payload
        },
    },
})

export const { errorAction } = errorSlice.actions

export default errorSlice.reducer
